export default "__VITE_ASSET__Bcedltj0__"